import React from 'react';

import Classic from "../image/Classic.jpg";
import Elegant from "../image/Elegant.jpg";
import Modern from "../image/Modern.jpg";
import Simple from "../image/Simple.jpg";


const Design = () => {
    return (
        <div>
            <div className='DESIGN-container'>
                <div className='DESIGN-view-image'>
                    <div><img src={Classic} /><p>Classic</p></div>
                    <div><img src={Elegant}/><p>Elegant</p></div>
                    <div><img src={Modern} /><p>Modern</p></div>
                    <div><img src={Simple} /><p>Simple</p></div>
                </div>
            </div>
        </div>
    );
};

export default Design;